var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a Recurring Payment"},on:{"on-hide":_vm.resetFormData}},[_c('recurring-payment-form',{key:_vm.formKey,attrs:{"technician-payment-id":_vm.technicianPaymentId,"user_id":_vm.userId},on:{"on-submit":_vm.create,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }